import { render, staticRenderFns } from "./angebote.vue?vue&type=template&id=2c463a1c&"
import script from "./angebote.vue?vue&type=script&lang=js&"
export * from "./angebote.vue?vue&type=script&lang=js&"
import style0 from "./angebote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports